import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button } from '@Knowledge-OTP/znk-ui-components'
import useAllGlobalVars from '../GlobalCounselors/Models/useGlobalVars'
import UseUpdateGlobalVar from '../GlobalCounselors/Models/updateGlobalVar'
import { showAlert } from '../../../common/Alert/util'

const INSTAGRAM_WIDGET_TYPE = 'instagramWidget'
const INSTAGRAM_WIDGET_GUIDE_VIDEO = 'https://drive.google.com/file/d/1kjotHupzuLIM-2KeNatG3SZ9CJAreP3j/preview'

const TokensView = () => {
  const dispatch = useDispatch()
  const { data: globalVarsData = [], loading: loadingGlobalVars } = useAllGlobalVars()
  const [longToken, setLongToken] = useState('')
  const [updateGlobalVar, { loading: loadingUpdateGlobalVar }] = UseUpdateGlobalVar()

  const instagramWidget = useMemo(
    () => globalVarsData.find(({ type }) => type === INSTAGRAM_WIDGET_TYPE),
    [globalVarsData]
  )

  useEffect(() => {
    setLongToken(globalVarsData.find(({ type }) => type === INSTAGRAM_WIDGET_TYPE)?.name || '')
  }, [globalVarsData])

  const handleSave = () => {
    if (!instagramWidget?.id) {
      showAlert(
        {
          text: 'Instagram widget global var not found',
          status: 'error'
        },
        dispatch
      )
      return
    }

    updateGlobalVar({
      variables: {
        globalVarId: instagramWidget.id,
        serviceUpdate: {
          type: INSTAGRAM_WIDGET_TYPE,
          name: longToken || '',
          value: 0,
          isActive: true
        }
      }
    }).then(
      () => {
        showAlert(
          {
            text: 'Instagram widget updated successfully',
            status: 'success'
          },
          dispatch
        )
      },
      () => {
        showAlert(
          {
            text: 'Error updating Instagram widget',
            status: 'error'
          },
          dispatch
        )
      }
    )
  }

  return (
    <div className='d-flex flex-column mt-5 col-12 col-md-8 col-lg-6 px-0'>
      <label htmlFor='instagram-widget-input' className='mb-2'>
        Instagram widget token
      </label>
      <input
        id='instagram-widget-input'
        type='text'
        className='form-control'
        value={longToken}
        disabled={loadingGlobalVars}
        onChange={(e) => setLongToken(e.target.value)}
        placeholder='Enter instagram widget token'
      />

      <Button
        color='primary'
        className='mt-3 align-self-start'
        label='Save'
        onClick={handleSave}
        disabled={loadingGlobalVars || loadingUpdateGlobalVar}
        activity={loadingUpdateGlobalVar}
      />

      <div className='mt-5'>
        <h6 className='mb-2'>Guide</h6>
        <p className='text-muted mb-3'>Video with explanations to upload the token.</p>
        <div style={{ position: 'relative', width: '100%', paddingBottom: '56.25%' }}>
          <iframe
            title='Instagram widget guide'
            src={INSTAGRAM_WIDGET_GUIDE_VIDEO}
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
            allow='autoplay; fullscreen'
            allowFullScreen
          />
        </div>
      </div>
    </div>
  )
}

export default TokensView
